import { useQuery } from "@tanstack/react-query";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import { fetchWithError } from "src/react-query/fetchWithError";
import { queryKeys } from "src/react-query/queryKeys";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";

const STAT_LABELS = [
  { key: "new_application", label: "New applications" },
  { key: "under_review", label: "Under review" },
  { key: "waiting_for_customer", label: "Waiting for customer" },
  { key: "rejected", label: "Rejected" },
  { key: "provisioning_done", label: "Provisioning done" },
  { key: "provisioning_failed", label: "Provisioning failed" },
  { key: "kyc_pending", label: "KYC pending" },
  { key: "bank_pending", label: "Bank pending" },
  { key: "accepted_provisioning_pending", label: "Accepted, provisioning pending" },
];

const StatCard = ({ label, value, loading }) => (
  <Card variant="outlined" sx={{ p: 2.5, borderRadius: 2 }}>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      {label}
    </Typography>
    {loading ? (
      <Skeleton variant="text" width={40} height={40} />
    ) : (
      <Typography variant="h4" fontWeight={600}>
        {value ?? 0}
      </Typography>
    )}
  </Card>
);

const StatisticsSection = () => {
  const { teamId: companyId } = useSelectedTeam();

  const { data: response, isFetching } = useQuery(
    queryKeys.mobileCpoOnboardingStats(companyId),
    fetchWithError,
    { enabled: !!companyId }
  );

  const stats = response?.data?.reduce((acc, { key, count }) => ({ ...acc, [key]: count }), {}) ?? {};

  return (
    <Grid container spacing={2}>
      {STAT_LABELS.map(({ key, label }) => (
        <Grid item xs={6} sm={3} key={key}>
          <StatCard label={label} value={stats[key]} loading={isFetching} />
        </Grid>
      ))}
    </Grid>
  );
};

export default StatisticsSection;
